import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppLayout } from '../../components/layout/AppLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { 
  Wallet, 
  ArrowLeftRight, 
  PiggyBank, 
  Users, 
  Gift,
  Receipt,
  TrendingUp,
  Banknote,
  ChevronRight
} from 'lucide-react';

export const FinancePage = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: 'Wallets & Balances',
      icon: Wallet,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50 dark:bg-blue-950',
      items: [
        { label: 'View All Wallets', path: '/user/wallets', icon: Wallet },
        { label: 'Transaction History', path: '/user/wallets', icon: Receipt },
      ]
    },
    {
      title: 'Send & Receive',
      icon: ArrowLeftRight,
      color: 'text-green-600',
      bgColor: 'bg-green-50 dark:bg-green-950',
      items: [
        { label: 'Transfer Money', path: '/user/transfer', icon: ArrowLeftRight },
        { label: 'Deposit Funds', path: '/user/deposit', icon: Banknote },
        { label: 'Withdraw Money', path: '/user/withdraw', icon: TrendingUp },
        { label: 'Currency Swap', path: '/user/swap', icon: ArrowLeftRight },
      ]
    },
    {
      title: 'Savings & Investments',
      icon: PiggyBank,
      color: 'text-purple-600',
      bgColor: 'bg-purple-50 dark:bg-purple-950',
      items: [
        { label: 'My Savings Plans', path: '/user/savings', icon: PiggyBank },
        { label: 'Growth Packages', path: '/user/growth-packages', icon: TrendingUp },
        { label: 'My Growth Packages', path: '/user/my-growth-packages', icon: TrendingUp },
        { label: 'Community Savings (Groups)', path: '/user/groups', icon: Users },
      ]
    },
    {
      title: 'Rewards',
      icon: Gift,
      color: 'text-orange-600',
      bgColor: 'bg-orange-50 dark:bg-orange-950',
      items: [
        { label: 'Referral Centre', path: '/user/referrals', icon: Gift },
        { label: 'Task Rewards', path: '/user/tasking', icon: Gift },
      ]
    },
  ];

  return (
    <AppLayout>
      <div className="p-4 space-y-6">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Finance</h1>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Manage your money, savings, and rewards
          </p>
        </div>

        {/* Sections */}
        <div className="space-y-4">
          {sections.map((section) => {
            const SectionIcon = section.icon;
            return (
              <Card key={section.title}>
                <CardHeader className="pb-3">
                  <div className="flex items-center gap-3">
                    <div className={`${section.bgColor} p-2 rounded-lg`}>
                      <SectionIcon className={`h-5 w-5 ${section.color}`} />
                    </div>
                    <CardTitle className="text-lg">{section.title}</CardTitle>
                  </div>
                </CardHeader>
                <CardContent className="space-y-2">
                  {section.items.map((item) => {
                    const ItemIcon = item.icon;
                    return (
                      <button
                        key={item.label}
                        onClick={() => navigate(item.path, { state: { fromSuperApp: true } })}
                        className="w-full flex items-center justify-between p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors text-left"
                      >
                        <div className="flex items-center gap-3">
                          <ItemIcon className="h-4 w-4 text-gray-600 dark:text-gray-400" />
                          <span className="text-sm font-medium text-gray-900 dark:text-white">
                            {item.label}
                          </span>
                        </div>
                        <ChevronRight className="h-4 w-4 text-gray-400" />
                      </button>
                    );
                  })}
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </AppLayout>
  );
};
